import { useDispatch, useSelector } from "react-redux";
import ASCButton from "../../components/Button";
import { AppDispatch, RootState } from "../../redux/store";
import {
  convertStringToArray,
  formatedDate,
  formatedTime,
  isObjectEmpty,
} from "../../utils";
import {
  openActionListDetailPopup,
  setActionListSelectedItem,
} from "../../redux/appSettingsSlice";
import { DocumentBulletList20Regular } from "@fluentui/react-icons";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Divider,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  Label,
  makeStyles,
  OverlayDrawer,
  Tag,
  Toaster,
  Tooltip,
} from "@fluentui/react-components";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import MaterialReactTable, {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_SortingState,
} from "material-react-table";
import defaultTableConfig from "../../shared/tableConfig.json";
import { useEffect, useMemo, useState } from "react";
import { ActionListRow } from "../../types/client";
import {
  applyTableFilters,
  clearTableFilters,
  fetchTableData,
  resetTableStateToDefault,
  saveTableState,
  selectHasTemporaryChanges,
  selectTableColumnOrder,
  selectTableDraftFilters,
  selectTableListData,
  selectTablePagination,
  selectTableSorting,
  setTableColumnOrder,
  setTableDraftFilter,
  setTablePagination,
  setTableSorting,
  DEFAULT_ACTION_CATEGORIES,
  DEFAULT_ACTION_DATE,
  DEFAULT_ACTION_STATUS,
  selectTableAppliedFiltersJson,
  selectIsDefaultPreference,
  selectTableAppliedFilters,
} from "../../redux/preferenceSlice";
import {
  ArrowClockwise20Regular,
  ArrowSwap20Regular,
  FilterDismiss20Regular,
} from "@fluentui/react-icons";
import ReactQuillComponent from "../../components/ReactQuillComponent";
import Search from "../../components/Search";
import { DropdownDatepicker } from "../../components/DropdownwithDatepicker";
import Multiselectsearch from "../../components/MultiSearchDropdown";
import apiServices from "../../service";
import ModalDialog from "../../components/ModalDialog";
import { Dismiss24Regular } from "@fluentui/react-icons";
import ActionListDetails from "./actionListDetails";
import { getCustomerReview } from "./Services";
import ActionListForm from "./ActionListForm";
import ContentLoader from "../../components/Loader/ContentLoader";
import { isEqual } from "lodash";
import { useActiveRowItemSync } from "./useActiveRowItemSync";
import { shouldStepBackPage } from "./shouldStepBackPage";

const useStyles = makeStyles({
  divider: {
    flexGrow: 0,
  },
});
const TABLE_NAME = "ACTION_LIST";

const actionCategories = [
  { label: "Client Action", value: "client_action" },
  { label: "Asset (Banks) Review", value: "asset_bank_review" },
  { label: "Asset (Home/Person)", value: "asset_home_review" },
  { label: "Asset (Investment) Review", value: "asset_investment_review" },
  { label: "Asset (Shares) Review", value: "asset_shares_review" },
  { label: "Case Tracking Action", value: "case_tracking_action" },
  { label: "Client Review", value: "client_review" },
  { label: "Credit Card Review Date", value: "credit_review_date" },
  { label: "Loan Review Date", value: "loan_review_date" },
  { label: "Mortgage Review Date", value: "mortgage_review_date" },
  { label: "Policy Review Date", value: "policy_review_date" },
  { label: "Birthday", value: "birthday" },
];
const caseCategoryMap: any = {
  "Asset(Banks) Review": apiServices.assets.getDetail,
  "Asset(Home) Review": apiServices.assets.getDetail,
  "Asset(Investment) Review": apiServices.assets.getDetail,
  "Asset(Shares) Review": apiServices.assets.getDetail,
  "Credit Card Review Date": apiServices.liability.getDetail,
  "Loan Review Date": apiServices.liability.getDetail,
  "Mortgage Review Date": apiServices.liability.getDetail,
  "Policy Review Date": apiServices.policy.getDetail,
};
const CaseCateoryListMaping: any = {
  "Unit-linked": "Asset(Investment) Review",
  "Banks/B Societies": "Asset(Banks) Review",
  Shares: "Asset(Shares) Review",
  "Home/Personal": "Asset(Home) Review",
  "Life Assurance": "Policy Review Date",
  Pensions: "Policy Review Date",
  Investements: "Policy Review Date",
  "Savings Plans": "Policy Review Date",
  "Income Protection": "Policy Review Date",
  "Health Assurance": "Policy Review Date",
  General: "Policy Review Date",
  Mortgages: "Mortgage Review Date",
  "Loans/Lease/HP": "Loan Review Date",
  "Credit Cards": "Credit Card Review Date",
};
const businessCategoryMap: {
  [key: number]: (itemId: string, customerId: string) => Promise<any>;
} = {
  2: apiServices.assets.getDetail,
  6: apiServices.liability.getDetail,
  7: apiServices.liability.getDetail,
  1: apiServices.policy.getDetail,
};
function List() {
  const styles = useStyles();
  const dispatch: AppDispatch = useDispatch();
  const { showToast, toasterId } = useToastMessage();

  /* ================= REDUX ================= */
  const appSettings = useSelector((state: RootState) => state.appSettings);
  const loggedUser = useSelector((state: RootState) => state.authUser);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const { preferences } = useSelector((state: RootState) => state.preferences);
  const preferencesStatus = useSelector(
    (state: RootState) => state.preferences.status,
  );
  const appliedFiltersJson = useSelector(
    selectTableAppliedFiltersJson(TABLE_NAME),
  );
  const isDefaultPreference = useSelector(
    selectIsDefaultPreference(TABLE_NAME)
  );
  const appliedFilters = useSelector(selectTableAppliedFilters(TABLE_NAME));
  const savedFilter = preferences.tables.contextSpecific[TABLE_NAME]?.filter;
  const draftFilters = useSelector(selectTableDraftFilters(TABLE_NAME));
  const pagination = useSelector(selectTablePagination(TABLE_NAME));
  const sorting = useSelector(selectTableSorting(TABLE_NAME));
  const columnOrder = useSelector(selectTableColumnOrder(TABLE_NAME));
  const listData = useSelector(selectTableListData(TABLE_NAME));
  const hasTemporaryChanges = useSelector(
    selectHasTemporaryChanges(TABLE_NAME),
  );

  /* ================= LOCAL STATE ================= */
  const [rowSelection, setRowSelection] = useState({});
  const [activeRowItem, setActiveRowItem] = useState<any | {}>({});
  const [updateActionData, setUpdateActionData] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [updateActionItemData, setUpdateActionItemData] = useState<any | {}>(
    {},
  );
  const [selectedRowDetail, setSelectedRowDetail] = useState<any | {}>({});
  const [isAdvancedFilterOpen, setIsAdvancedFilterOpen] = useState(false);
  const [optionDateValue, setOptionDateValue] = useState(
    "Next 31 Days Plus Overdue",
  );
  const [isDateMenuOpen, setIsDateMenuOpen] = useState(false);
  const [dateContext, setDateContext] = useState(""); // defineDates | others
  const [statusOptions, setStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [consultantOptions, setConsultantOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [assigneeOptions, setAssigneeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [assigneeLoading, setAssigneeLoading] = useState(false);
  const [consultantLoading, setConsultantLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);

  const [localDraftFilters, setLocalDraftFilters] = useState({
    search: draftFilters.search || "",
    category: draftFilters.category?.length
      ? draftFilters.category
      : DEFAULT_ACTION_CATEGORIES,
    dateCondition: draftFilters.dateCondition ?? DEFAULT_ACTION_DATE,
    consultant: draftFilters.consultant || [],
    assignee: draftFilters.assignee || [],
    status:
      draftFilters.status !== undefined
        ? draftFilters.status
        : savedFilter?.status,
  });

  const normalizeForComparison = (f: any) => {
    const status = Array.isArray(f.status) ? [...f.status].sort() : f.status;
    // Treat "all options selected" the same as [] (no filter) for comparison
    const normalizedStatus =
      statusOptions.length > 0 && Array.isArray(status) && status.length === statusOptions.length
        ? []
        : status;
    return {
      ...f,
      category: [...(f.category || [])].sort(),
      consultant: [...(f.consultant || [])].sort(),
      assignee: [...(f.assignee || [])].sort(),
      status: normalizedStatus,
    };
  };

  const disableApply = isEqual(
    normalizeForComparison(localDraftFilters),
    normalizeForComparison(appliedFilters),
  );
  /* ================= TABLE CONFIG ================= */
  const tableConfig =
    preferences.tables.contextSpecific[TABLE_NAME] ??
    defaultTableConfig.tables.contextSpecific[TABLE_NAME];

  const CELL_RENDERER_MAP: Record<string, (props: any) => JSX.Element> = {
    formatedDate: ({ cell }) => <span>{formatedDate(cell.getValue())}</span>,
    formatedTime: ({ cell }) => <span>{formatedTime(cell.getValue())}</span>,
    ReactQuillComponent: ({ cell }) => (
      <ReactQuillComponent value={cell.getValue()} />
    ),
  };

  const FILTER_FN_MAP: Record<
    string,
    (row: any, columnId: any, filterValue: any) => boolean
  > = {
    formattedDate: (row, columnId, filterValue) =>
      formatedDate(row.getValue(columnId))
        .toLowerCase()
        .includes(String(filterValue).trim().toLowerCase()),
    formattedTime: (row, columnId, filterValue) =>
      formatedTime(row.getValue(columnId))
        .toLowerCase()
        .includes(String(filterValue).trim().toLowerCase()),
  };

  const columns = useMemo<MRT_ColumnDef<ActionListRow>[]>(() => {
    return (tableConfig.columns ?? []).map((col: any) => ({
      ...col,
      ...(col.Cell && typeof col.Cell === "string"
        ? { Cell: CELL_RENDERER_MAP[col.Cell] ?? undefined }
        : {}),
      ...(col.filterFn && typeof col.filterFn === "string"
        ? { filterFn: FILTER_FN_MAP[col.filterFn] ?? undefined }
        : {}),
    })) as MRT_ColumnDef<ActionListRow>[];
  }, [tableConfig]);

  /* ================= USEEFFECTS ================= */


  useEffect(() => {
    setLocalDraftFilters({
      search: draftFilters.search || "",
      category: draftFilters.category?.length
        ? draftFilters.category
        : DEFAULT_ACTION_CATEGORIES,
      dateCondition: draftFilters.dateCondition ?? DEFAULT_ACTION_DATE,
      consultant: draftFilters.consultant || [],
      assignee: draftFilters.assignee || [],
      status:
        draftFilters.status !== undefined
          ? draftFilters.status
          : savedFilter?.status,
    });
  }, [
    draftFilters.search,
    draftFilters.category,
    draftFilters.dateCondition,
    draftFilters.consultant,
    draftFilters.assignee,
    draftFilters.status,
  ]);
  // Re-validated against the CURRENT listData whenever it changes -- not
  // just when rowSelection changes -- so completing/updating the selected
  // action (which refreshes listData but not rowSelection) doesn't leave
  // this pointing at stale, pre-refresh data. See useActiveRowItemSync.ts.
  useActiveRowItemSync(listData?.data, rowSelection, setActiveRowItem);
  useEffect(() => {
    if (activeRowItem) {
      dispatch(setActionListSelectedItem(activeRowItem));
    }
  }, [activeRowItem]);
  // Fetch data only after preferences loaded
  // Load status options on mount so the chip and dropdown show "All" immediately.
  // Also auto-populate localDraftFilters.status with all options whenever it is
  // empty ([] = default "All") and options are available — covers initial load,
  // clear-filter, and reset-to-default.
  useEffect(() => {
    getStatusOptions();
  }, []);

  // Only runs when options first load — does NOT re-run when user deselects all,
  // so Select All can be used to toggle the selection off.
  useEffect(() => {
    if (statusOptions.length > 0 && (!localDraftFilters.status || localDraftFilters.status.length === 0)) {
      setLocalDraftFilters((p) => ({
        ...p,
        status: statusOptions.map((o) => o.value),
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusOptions.length]);

  useEffect(() => {
    if (preferencesStatus !== "succeeded") return;
    dispatch(
      fetchTableData({
        tableName: TABLE_NAME,
        params: { page: pagination.pageIndex + 1, limit: pagination.pageSize },
      }),
    );
  }, [
    dispatch,
    preferencesStatus,
    pagination.pageIndex,
    pagination.pageSize,
    appliedFiltersJson,
  ]);

  useEffect(() => {
    if (appSettings?.actionListDetailPopup) {
      if (!isObjectEmpty(activeRowItem)) {
        setDataLoading(true);
        setSelectedRowDetail([]);
        if (
          activeRowItem?.category === "Client Action" ||
          activeRowItem?.category === "Client Review" ||
          activeRowItem?.category === "Birthday"
        ) {
          getCustomerDetail(activeRowItem?.customer_id);
        } else if (activeRowItem?.category === "Case Tracking Action") {
          getCaseActionDetails(activeRowItem);
        } else {
          getCaseDetail(activeRowItem);
        }
      }
    }
  }, [appSettings?.actionListDetailPopup]);

  const FilterChip = ({
    label,
    selectedItems,
    total,
    onClick,
  }: {
    label: string;
    selectedItems: string[];
    total: number;
    onClick: () => void;
  }) => {
    if (!selectedItems || selectedItems.length === 0) return null;

    let processedItems = selectedItems;

    if (label === "Category") {
      processedItems = selectedItems.map(
        (val) =>
          actionCategories.find((opt) => opt.value === val)?.label || val
      );
    }

    const count = processedItems.length;

    let displayText = "";

    if (count === total) {
      displayText = `${label}: All`;
    } else if (count <= 2) {
      displayText = `${label}: ${processedItems.join(", ")}`;
    } else {
      const firstTwo = processedItems.slice(0, 2);
      const remaining = count - 2;
      displayText = `${label}: ${firstTwo.join(", ")} +${remaining}`;
    }

    return (
      <Tooltip
        relationship="label"
        positioning="below"
        content={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
            }}
          >
            {processedItems.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </div>
        }
      >
        <Tag
          shape="circular"
          appearance="outline"
          size="small"
          style={{ cursor: "pointer" }}
          onClick={onClick}
        >
          {displayText}
        </Tag>
      </Tooltip>
    );
  };
  const getCompactPlaceholder = (
    selected: string[],
    field?: string,
  ) => {
    if (!selected || selected.length === 0) return "";

    let processedItems = selected;

    // 🔥 Only map values → labels for Category
    if (field === "Category") {
      processedItems = selected.map(
        (val) =>
          actionCategories.find((opt) => opt.value === val)?.label || val
      );
    }

    // ✅ Show all selected labels
    return processedItems.join(", ");
  };
  /* ================= HANDLERS ================= */
  const savedConfig = useMemo(
    () => preferences.tables.contextSpecific[TABLE_NAME],
    [preferences.tables.contextSpecific, TABLE_NAME]
  );
  const handleApplyFilter = () => {
    dispatch(
      setTableDraftFilter({
        tableName: TABLE_NAME,
        filter: {
          search: localDraftFilters.search,
          category: localDraftFilters.category,
          dateCondition: localDraftFilters.dateCondition,
          consultant: localDraftFilters.consultant,
          assignee: localDraftFilters.assignee,
          status: localDraftFilters.status,
        },
      }),
    );
    dispatch(applyTableFilters({ tableName: TABLE_NAME }));
  };

  const handleClearFilter = () => {
    dispatch(clearTableFilters({ tableName: TABLE_NAME }));
    setLocalDraftFilters({
      search: savedFilter?.search || "",
      category: savedFilter?.category?.length
        ? savedFilter.category
        : DEFAULT_ACTION_CATEGORIES,
      dateCondition: savedFilter?.dateCondition ?? DEFAULT_ACTION_DATE,
      consultant: savedFilter?.consultant || [],
      assignee: savedFilter?.assignee || [],
      status: savedFilter?.status?.length
        ? savedFilter.status
        : statusOptions.length > 0 ? statusOptions.map((o) => o.value) : DEFAULT_ACTION_STATUS,
    });
    setOptionDateValue("Next 31 Days Plus Overdue");
  };
  const handleResetToDefault = async () => {
    try {
      await dispatch(
        resetTableStateToDefault({ tableName: TABLE_NAME }),
      ).unwrap();
      setLocalDraftFilters({
        search: "",
        category: DEFAULT_ACTION_CATEGORIES,
        dateCondition: DEFAULT_ACTION_DATE,
        consultant: [],
        assignee: [],
        status: statusOptions.length > 0 ? statusOptions.map((o) => o.value) : DEFAULT_ACTION_STATUS,
      });
      setOptionDateValue("Next 31 Days Plus Overdue");
      showToast("User preferences have been reset to default.", "", "success");
    } catch {
      showToast("Failed to reset preferences", "", "error");
    }
  };

  const handleSavePreference = async () => {
    try {
      const { message } = await dispatch(
        saveTableState({ tableName: TABLE_NAME, shouldRefetch: true }),
      ).unwrap();
      showToast("User preferences have been updated successfully.", "", "success");
    } catch {
      showToast("Failed to save preferences", "", "error");
    }
  };
  const hasTableChanges = useMemo(() => {
    if (!savedConfig) return false;

    return !isEqual(
      {
        filter: appliedFilters,
        pagination,
        sorting,
        columnOrder,
      },
      {
        filter: savedConfig.filter,
        pagination: savedConfig.initialState?.pagination,
        sorting: savedConfig.initialState?.sorting,
        columnOrder: savedConfig.initialState?.columnOrder,
      }
    );
  }, [appliedFilters, pagination, sorting, columnOrder, savedConfig]);
  const handlePaginationChange = (
    updater:
      | MRT_PaginationState
      | ((prev: MRT_PaginationState) => MRT_PaginationState),
  ) => {
    const next = typeof updater === "function" ? updater(pagination) : updater;
    dispatch(setTablePagination({ tableName: TABLE_NAME, pagination: next }));
  };

  const handleSortingChange = (
    updater: MRT_SortingState | ((prev: MRT_SortingState) => MRT_SortingState),
  ) => {
    const next = typeof updater === "function" ? updater(sorting) : updater;
    dispatch(setTableSorting({ tableName: TABLE_NAME, sorting: next }));
  };

  const handleColumnOrderChange = (
    updater: string[] | ((prev: string[]) => string[]),
  ) => {
    const next = typeof updater === "function" ? updater(columnOrder) : updater;
    dispatch(setTableColumnOrder({ tableName: TABLE_NAME, columnOrder: next }));
  };
  /* ================= API ================= */
  const getConsultantOptions = async () => {
    if (consultantOptions.length > 0) return;

    try {
      setConsultantLoading(true);

      const res = await apiServices.actionList.getConsultant(
        loggedUser.userId,
      );

      if (Array.isArray(res.data.data)) {
        setConsultantOptions(
          res.data.data.map((c: string) => ({
            label: c,
            value: c,
          })),
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setConsultantLoading(false);
    }
  };

  const getAssigneeOptions = async () => {
    if (assigneeOptions.length > 0) return;

    try {
      setAssigneeLoading(true);

      const res = await apiServices.actionList.getAssignee(
        loggedUser.userId,
      );

      if (Array.isArray(res.data.data)) {
        setAssigneeOptions(
          res.data.data.map((a: string) => ({
            label: a,
            value: a,
          })),
        );
      }
    } catch (e) {
      console.error(e);
    } finally {
      setAssigneeLoading(false);
    }
  };

  const getStatusOptions = async () => {
    if (statusOptions.length > 0) return;

    try {
      setStatusLoading(true);

      const fieldLbl =
        "appointment_status:ModifiableList,business_status:ModifiableList,investment_status:ModifiableList,share_status:ModifiableList,bank_status:ModifiableList,status:ModifiableList";

      const res = await apiServices.selectionList.getOptions(fieldLbl);

      if (res.data?.data?.length > 0) {
        const allOptions = res.data.data.flatMap(
          (field: any) => field.options,
        );

        const seen = new Set<string>();

        const unique = allOptions.filter(({ value }: any) => {
          if (seen.has(value)) return false;
          seen.add(value);
          return true;
        });

        const emptyOption = { label: "(None)", value: "" };

        setStatusOptions([emptyOption, ...unique]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setStatusLoading(false);
    }
  };
  const getCustomerDetail = (customerId: string) => {
    fetchClientDetail(apiServices.client.getDetail, customerId);
  };

  const getCustomerActionDetail = (customerId: string, actionId: string) => {
    apiServices.contactClientAction
      .getById(actionId, customerId)
      .then((response: any) => {
        setDataLoading(false);
        if (
          response.data &&
          !response.data.isError &&
          !isObjectEmpty(response.data.data)
        ) {
          setUpdateActionItemData({
            date: response?.data?.data.appointment_date,
            time: response?.data?.data.appointment_time,
            type: response?.data?.data.appointment_type,
            description: response?.data?.data.appointment_note,
            assigned: response?.data?.data.appointment_assigned,
            status: response?.data?.data.appointment_status,
            category: "Client Action",

            customer_id: customerId,
            appointment_id: actionId,
            case_type: activeRowItem?.case_type,
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
        setDataLoading(false);
      });
  };
  const getCaseActionDetails = (rowItem: any) => {
    const apiCall = businessCategoryMap[rowItem?.business_category];
    if (apiCall) {
      fetchDetail(apiCall, rowItem?.case_id, rowItem?.customer_id);
    } else {
      setDataLoading(false);
      console.error("No matching business_category found");
    }
  };
  const getItemDetail = async (row: any) => {
    setDataLoading(true);
    if (!isObjectEmpty(row)) {
      let activeRowItem = row;
      if (activeRowItem?.category === "Client Action") {
        getCustomerActionDetail(
          activeRowItem?.customer_id,
          activeRowItem?.case_id,
        );
      } else if (activeRowItem?.category === "Client Review") {
        setDataLoading(true);
        const customerReview = await getCustomerReview(
          activeRowItem?.customer_id,
        );

        if (customerReview) {
          setDataLoading(false);
          setUpdateActionItemData({
            review_interval: customerReview.review_interval,
            review_reason: customerReview.review_note,
            review_assigned: customerReview.review_assigned,
            review_completed: customerReview.review_completed,
            consultant_id: customerReview.consultant_id,
            consultant: customerReview.consultant,
            review_date: customerReview.review_date,
            category: "Client Review",
            customer_id: activeRowItem?.customer_id,
            case_type: activeRowItem?.case_type,
          });
        } else {
          setDataLoading(false);
        }
      } else if (activeRowItem?.category === "Case Tracking Action") {
        setUpdateActionItemData({
          action_date: activeRowItem?.action_date,
          description: activeRowItem?.description,
          assigned: activeRowItem?.assigned,
          status: activeRowItem?.status,
          category: "Case Tracking Action",
          case_id: activeRowItem?.case_id,
          customer_id: activeRowItem?.customer_id,
          business_category: activeRowItem?.business_category,
          case_type: activeRowItem?.case_type,
          business_id: activeRowItem?.business_id,
        });
        setDataLoading(false);
      } else {
        getCaseDetail(activeRowItem);
        setDataLoading(false);
      }
    }
  };
  const fetchClientDetail = (
    apiCall: (customerId: string) => Promise<any>,
    customerId: string,
  ) => {
    apiCall(customerId)
      .then((response: any) => {
        setDataLoading(false);
        if (
          response.data &&
          !response.data.isError &&
          !isObjectEmpty(response.data.data)
        ) {
          setSelectedRowDetail(response.data.data);
        }
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
      });
  };
  const getCaseDetail = (rowItem: any) => {
    const apiCall = caseCategoryMap[rowItem?.category];

    if (apiCall) {
      fetchDetail(apiCall, rowItem?.case_id, rowItem?.customer_id);
    } else {
      setDataLoading(false);
      console.error("No matching case_type found");
    }
  };
  const fetchDetail = (
    apiCall: (itemId: string, customerId: string) => Promise<any>,
    itemId: string,
    customerId: string,
  ) => {
    apiCall(itemId, customerId)
      .then(handleSuccessResponse)
      .catch(handleErrorResponse);
  };
  const handleSuccessResponse = (response: any) => {
    setDataLoading(false);
    if (
      response.data &&
      !response.data.isError &&
      !isObjectEmpty(response.data.data)
    ) {
      setSelectedRowDetail(response.data.data);
      setUpdateActionItemData({
        date: response?.data?.data.review_date,
        review_interval: response?.data?.data.review_interval,
        review_reason: response?.data?.data.review_reason,
        review_assigned: response?.data?.data.review_assigned,
        category: CaseCateoryListMaping[response?.data?.data.case_type] || "",
        case_type: response?.data?.data.case_type || "",
        review_completed: response?.data?.data.review_completed,
        customer_id: response?.data?.data.customer_id,
        caseId:
          response.data?.data?.policy_id ||
          response.data?.data?.liability_id ||
          response.data?.data?.asset_id ||
          "",
        owner:
          response.data?.data?.policy_holder ||
          response.data?.data?.joint_indicator ||
          0,
      });
    } else if (response.data.isError) {
      if (
        response.data.error &&
        Object.keys(response.data.error).length !== 0
      ) {
        let errorMessage = "";

        if (Array.isArray(response.data.error.message)) {
          errorMessage = response.data.error.message.join("\n");
        } else {
          errorMessage = response.data.error.message;
        }
        showToast(errorMessage, "", "error");
        setUpdateActionData(false);
      }
    } else {
      showToast("Something went wrong", "", "error");
    }
  };
  const handleErrorResponse = (err: any) => {
    setDataLoading(false);
    console.log(err);
    showToast(err.message, "", "error");
  };
  const refreshData = () => {
    dispatch(
      fetchTableData({
        tableName: TABLE_NAME,
        params: { page: pagination.pageIndex + 1, limit: pagination.pageSize },
      }),
    ).then((result: any) => {
      // If completing/updating the action emptied the last page (rare with
      // the 200-row default, but possible with narrow filters), step back
      // one page -- the pagination.pageIndex effect above refetches it.
      if (shouldStepBackPage(result?.payload?.data, pagination.pageIndex)) {
        dispatch(
          setTablePagination({
            tableName: TABLE_NAME,
            pagination: { ...pagination, pageIndex: pagination.pageIndex - 1 },
          }),
        );
      }
    });
  };
  /* ================= MRT CONFIG ================= */
  const sortingConfig = tableConfig.sortingConfig;

  const config = useMemo(
    () => ({
      ...preferences.tables.defaultConfig,
      enablePagination: true,
      manualPagination: true,
      enableSorting: true,
      enableColumnOrdering: true,
      enableColumnDragging: true,
      initialState: {
        ...tableConfig.initialState,
        pagination,
        sorting,
        columnOrder,
        density: "compact" as const,
      },
      ...(sortingConfig?.sortableColumns && {
        columns: columns.map((col: any) => ({
          ...col,
          enableSorting: sortingConfig.sortableColumns.includes(
            col.accessorKey,
          ),
        })),
      }),
    }),
    [
      preferences.tables.defaultConfig,
      tableConfig,
      pagination,
      sorting,
      columnOrder,
      columns,
      sortingConfig,
    ],
  );

  /* ================= RENDER ================= */
  return (
    <div className="padding_20">
      <div className="flex-end">
        {!convertStringToArray(process.env.REACT_APP_HIDE_CTA_BUTTON).includes(
          "actionlist_detail_btn",
        ) && (
            <ASCButton
              shape="rounded"
              onClick={() => dispatch(openActionListDetailPopup(true))}
              icon={<DocumentBulletList20Regular />}
              style={{ width: "fit-content" }}
              disabled={isObjectEmpty(appSettings.actionListSelectedItem)}
              label="Details"
            />
          )}
      </div>

      <div className="page-content-area">
        <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      </div>

      <div className="action-list-wrapper">
        <MaterialReactTable<any>
          columns={columns}
          data={listData?.data || []}
          rowCount={listData?.total || 0}
          manualPagination
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          onPaginationChange={handlePaginationChange}
          onSortingChange={handleSortingChange}
          onColumnOrderChange={handleColumnOrderChange}
          state={{
            rowSelection,
            pagination,
            sorting,
            columnOrder,
            isLoading: listData?.status === "loading",
          }}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10, 50, 100, 200, 500],
          }}
          {...config}
          muiToolbarAlertBannerProps={{ sx: { display: "none" } }}
          renderTopToolbarCustomActions={() => (
            <div className="table_filter">
              <div className="global-search-filter">
                <Search
                  placeholder="Search"
                  setSearch={(val) =>
                    setLocalDraftFilters((p: any) => ({ ...p, search: val }))
                  }
                  search={localDraftFilters.search}
                  width="150px"
                />

                <DropdownDatepicker
                  open={isDateMenuOpen}
                  setOpen={setIsDateMenuOpen}
                  context={dateContext}
                  setContext={setDateContext}
                  dateSelection={(val: any) =>
                    setLocalDraftFilters((p) => ({ ...p, dateCondition: val }))
                  }
                  dateLabel={setOptionDateValue}
                  optionDateValue={optionDateValue}
                  optionDate={localDraftFilters.dateCondition}
                />
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    padding: "3px 7px",
                    alignItems: "center",
                    borderRadius: 3,
                    border: "1px solid #cdcdcd",
                  }}
                >
                  <span
                    style={{ fontWeight: 600 }}
                    onClick={() => setIsAdvancedFilterOpen(true)}
                  >
                    Advanced:
                  </span>
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                    }}
                  >
                    <FilterChip
                      label="Category"
                      selectedItems={localDraftFilters.category}
                      total={actionCategories.length}
                      onClick={() => setIsAdvancedFilterOpen(true)}
                    />
                    <FilterChip
                      label="Assigned"
                      selectedItems={localDraftFilters.assignee}
                      total={
                        assigneeOptions.length
                      }
                      onClick={() => setIsAdvancedFilterOpen(true)}
                    />
                    <FilterChip
                      label="Consultant"
                      selectedItems={localDraftFilters.consultant}
                      total={
                        consultantOptions.length
                      }
                      onClick={() => setIsAdvancedFilterOpen(true)}
                    />
                    <FilterChip
                      label="Status"
                      selectedItems={localDraftFilters.status ?? []}
                      total={statusOptions.length}
                      onClick={() => setIsAdvancedFilterOpen(true)}
                    />
                  </div>
                </div>

                <ASCButton
                  shape="rounded"
                  className="asc-button-primary"
                  appearance="primary"
                  onClick={handleApplyFilter}
                  disabled={disableApply}
                  label="Apply"
                />

                {hasTemporaryChanges && (
                  <Tooltip content="Clear filter" relationship="label">
                    <Button
                      icon={<FilterDismiss20Regular />}
                      onClick={handleClearFilter}
                    />
                  </Tooltip>
                )}
                {!convertStringToArray(
                  process.env.REACT_APP_HIDE_CTA_BUTTON,
                ).includes("action_list_preference") && (

                    <>
                      <ASCButton
                        label="Save Preference"
                        shape="rounded"
                        appearance="secondary"
                        onClick={handleSavePreference}
                        disabled={!hasTableChanges}
                      />
                      <Tooltip content="Reset to Default" relationship="label">
                        <Button
                          icon={<ArrowClockwise20Regular />}
                          onClick={handleResetToDefault}
                          disabled={isDefaultPreference}
                        />
                      </Tooltip>

                    </>
                  )}
              </div>
            </div>
          )}
          muiTableContainerProps={({ table }) => ({
            sx: {
              height: table.getState().isFullScreen
                ? "calc(100vh - 90px) !important"
                : "calc(100vh - 290px) !important",
            },
          })}
          muiTableBodyRowProps={({ row }) => ({
            onDoubleClick: async () => {
              setRowSelection({ [row.id]: true });
              setUpdateActionItemData({});
              setActiveRowItem(row.original);

              setDataLoading(true);
              await getItemDetail(row.original);
              setUpdateActionData(true);
            },
            sx: {
              cursor: "pointer",
            },
          })}
          icons={{
            DragHandleIcon: () => (
              <ArrowSwap20Regular style={{ color: "000", cursor: "grab" }} />
            ),
          }}
        />
      </div>
      <ModalDialog options={dialogModalOptions} />
      {/* ================= ADVANCED FILTER DIALOG ================= */}
      <Dialog
        open={isAdvancedFilterOpen}
        onOpenChange={(_, data) => setIsAdvancedFilterOpen(data.open)}
      >
        <DialogSurface style={{ width: "720px" }}>
          <DialogBody>
            <DialogTitle>
              Advanced Filter
            </DialogTitle>
            <DialogContent
              style={{ display: "flex", gap: "16px", flexDirection: "column" }}
            >
              <div>
                <Label>Category</Label>
                <Multiselectsearch
                  fixed_width={false}
                  setSelectedDropDownValues={(val) =>
                    setLocalDraftFilters((p) => ({ ...p, category: val }))
                  }
                  selectedDropDownValues={localDraftFilters.category}
                  placeholder={
                    getCompactPlaceholder(
                      localDraftFilters.category,
                      "Category"
                    ) || "Choose by Action Category"
                  }
                  options={actionCategories}
                  allSelectedText="All categories"

                />
              </div>
              <div>
                <Label>Assignee</Label>
                <Multiselectsearch
                  fixed_width={false}
                  setSelectedDropDownValues={(val) =>
                    setLocalDraftFilters((p) => ({ ...p, assignee: val }))
                  }
                  selectedDropDownValues={localDraftFilters.assignee}
                  placeholder={
                    getCompactPlaceholder(
                      localDraftFilters.assignee
                    ) || "Choose Assignee"
                  }
                  options={assigneeOptions}
                  onOpenChange={(_: any, data: any) => {
                    if (data.open) getAssigneeOptions();
                  }}
                  allSelectedText="All Assignees"
                  loading={assigneeLoading}
                />
              </div>
              <div>
                <Label>Consultant</Label>
                <Multiselectsearch
                  fixed_width={false}
                  setSelectedDropDownValues={(val) =>
                    setLocalDraftFilters((p) => ({ ...p, consultant: val }))
                  }
                  selectedDropDownValues={localDraftFilters.consultant}
                  placeholder={
                    getCompactPlaceholder(
                      localDraftFilters.consultant
                    ) || "Choose Consultant"
                  }
                  options={consultantOptions}
                  onOpenChange={(_: any, data: any) => {
                    if (data.open) getConsultantOptions();
                  }}
                  allSelectedText="All Consultants"
                  loading={consultantLoading}
                />
              </div>
              <div>
                <Label>Status</Label>
                <Multiselectsearch
                  fixed_width={false}
                  select_all={true}
                  setSelectedDropDownValues={(val) =>
                    setLocalDraftFilters((p) => ({ ...p, status: val }))
                  }
                  onOpenChange={(_: any, data: any) => {
                    if (data.open) getStatusOptions();
                  }}
                  selectedDropDownValues={localDraftFilters.status ?? []}
                  placeholder={
                    (
                      !localDraftFilters.status || localDraftFilters.status.length === 0
                        ? statusOptions.map((o) => o.value)
                        : localDraftFilters.status
                    )
                      .map(
                        (val: any) =>
                          statusOptions.find((o) => o.value === val)?.label || val,
                      )
                      .filter(Boolean)
                      .join(", ") || "All Statuses"
                  }
                  options={statusOptions}
                  allSelectedText="All Statuses"
                  loading={statusLoading}
                />
              </div>
            </DialogContent>

            <DialogActions>
              <ASCButton
                appearance="secondary"
                shape="rounded"
                onClick={() => setIsAdvancedFilterOpen(false)}
                label={"Cancel"} />
              <ASCButton
                appearance="primary"
                className="asc-button-primary"
                shape="rounded"
                onClick={() => {
                  // handleApplyFilter();
                  setIsAdvancedFilterOpen(false);
                }}
                label={"Select"} />
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>

      {/* ================= ACTION LIST - UPDATE ================= */}
      <Dialog open={updateActionData} modalType="non-modal">
        <DialogSurface aria-modal="false">
          <DialogBody>
            <DialogContent>
              <ActionListForm
                data={updateActionItemData}
                showToast={showToast}
                cancelPopup={() => {
                  setUpdateActionData(false);
                }}
                getActionListData={refreshData}
                isDetailDataLoading={dataLoading}
                activeRowItem={activeRowItem}
              />
            </DialogContent>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      {/* ================= OVERLAY DRAWER - DETAIL ================= */}
      <OverlayDrawer
        position="end"
        open={appSettings?.actionListDetailPopup}
        onOpenChange={(_, { open }) =>
          dispatch(openActionListDetailPopup(open))
        }
        style={{ width: "450px", marginTop: "130px" }}
      >
        <DrawerHeader>
          <DrawerHeaderTitle
            action={
              <ASCButton
                shape="rounded"
                appearance="subtle"
                aria-label="Close"
                icon={<Dismiss24Regular />}
                onClick={() => dispatch(openActionListDetailPopup(false))}
              />
            }
          >
            {activeRowItem?.category}
          </DrawerHeaderTitle>
        </DrawerHeader>
        <Divider className={styles.divider} />

        <DrawerBody style={{ padding: "10px 20px" }}>
          {dataLoading ? (
            <ContentLoader />
          ) : (
            <ActionListDetails
              activeRowItem={activeRowItem}
              activeRowItemDetail={selectedRowDetail}
            />
          )}
        </DrawerBody>
      </OverlayDrawer>
    </div>
  );
}

export default List;
